













































import { Component, Prop, Mixins } from 'vue-property-decorator';
import ConversationData from '@/ts/ConversationData';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import PersonData from '@/ts/PersonData';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component
export default class ConversationListItem extends Mixins(DeviceMethods) {
    @Prop() public conversationData!: ConversationData;
    @Prop() public isActive!: boolean;

    constructor() {
        super();
    }

    get classes(): object {
        return {
            'hococo-conversation__isActive': (!this.mobileLayout && this.isActive),
            'hococo-conversation__isEmphasized': this.conversationData.emphasized,
        };
    }

    get lastImageAuthorName() {
        if (this.conversationData.lastMessage !== null && typeof this.conversationData.lastMessage !== 'undefined') {
            const participant =  this.$store.getters['User/getCacheUser'](this.conversationData.lastMessage.authorId);
            return participant ? `${participant.firstName} ${participant.familyName}` : '';
        }

        return null;
    }

    get lastMessageAuthorFirstInitial() {
        if (this.conversationData.lastMessage !== null && typeof this.conversationData.lastMessage !== 'undefined') {
            const participant =  this.$store.getters['User/getCacheUser'](this.conversationData.lastMessage.authorId);
            return participant ? participant.firstName.charAt(0) : '';
        }

        return '';
    }

    get participantImage() {
        if (this.conversationData.lastMessage !== null && typeof this.conversationData.lastMessage !== 'undefined') {
            const participant =  this.$store.getters['User/getCacheUser'](this.conversationData.lastMessage.authorId);

            if (participant) {
                if (!participant.fetchedMiniature) {
                    participant.fetchMiniature(this.$store);
                    participant.fetchedMiniature = true;
                }

                if (participant.hasMiniature || participant.hasProfileImage) {
                    if (participant.hasMiniature) {
                        return participant.miniatureImage;
                    }

                    if (participant.hasProfileImage) {
                        return participant.profileImage;
                    }
                }
            }
        }

        return null;
    }

    get property() {
        if (this.conversationData === null || this.conversationData.propertyId === null) {
            return null;
        }

        return this.$store.getters['Properties/getProperty'](this.conversationData.propertyId);
    }

    get conversationHeader(): string {
        if (this.conversationData.isUnderComposition) {
            return this.$t('general.new-conversation', 'New Conversation');
        }

        return this.conversationData.recipientNames;
    }

    get firstInitial() {
        if (!this.conversationData) {
            return '';
        }

        return this.conversationData.firstInitial;
    }

    get headerText() {
        if (!(this.conversationData && this.conversationData.propertyId)) {
            return '';
        }

        const property = this.$store.getters['Properties/getProperty'](this.conversationData.propertyId);
        const building = this.$store.getters['Buildings/getBuilding'](property.buildingId);

        if (!property || !property.titleNumber) {
            return building.name;
        }

        return `#${property.titleNumber} - ${property.address}`;
    }

    get buildingName() {
        if (!(this.conversationData && this.conversationData.propertyId)) {
            return '';
        }

        const property = this.$store.getters['Properties/getProperty'](this.conversationData.propertyId);
        const building = this.$store.getters['Buildings/getBuilding'](property.buildingId);

        return building.name;
    }

    get dataLoaded(): boolean {
        return (
            this.conversationData !== null
            && this.conversationData.participants !== null
            && this.conversationData.participants.constructor === Array
            && this.conversationData.participants.length > 0
            && this.conversationData.messages !== null
        );
    }

    public getUser(userId: number): PersonData {
        return this.$store.getters['User/getCacheUser'](userId);
    }
}
